import React, { Component } from "react";
import { connect } from "react-redux";
import { number } from "yup";
import CenteredPaper from "../layouts/CenteredPaper";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import { getTextSnippet } from "../util/forms/getTextSnippet";
import { IrqTitle } from "../molecules/IrqTitle";
import EditActions from "../schema/misc/EditActions";
import ILearn from "../molecules/ILearn";
import { ModifyDataPointModal } from "../molecules/ModifyDataPointModal";
import { CountyLimitsContext } from "../context/CountyLimitsContext";
import { getDownPaymentMinimum } from "../util/getDownPaymentMinimum";
import { LoadingIndicator } from "../atoms/LoadingIndicator";

class RefinanceIrqConfirmationView extends Component {
  static contextType = CountyLimitsContext;

  constructor() {
    super();
    this.state = {
      open: false,
      openDataName: null,
      firstTimeBuyer: localStorage.getItem("firstTimeBuyer"),
    };
    this.getPageData = this.getPageData.bind(this);
  }

  componentDidMount() {
    this.getPageData();
  }

  getPageData = async () => {
    await this.context.fetchCountyLimits();
  };

  openModalWithData = (data) => {
    this.setState({ open: true, openDataName: data });
  };

  render() {
    const { countyLimits } = this.context;

    if (countyLimits === null) {
      return (
        <div className="page-wrapper">
          <LoadingIndicator label="Fetching page data..." />
        </div>
      );
    }

    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle content={this.props.content} />
          <div className="main-confirmation-view-wrapper">
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                I'm looking to refinance my{" "}
                <span onClick={() => this.openModalWithData("propertyType")}>
                  {getTextSnippet("propertyType", this.props.data)}
                </span>{" "}
                property located at{" "}
                <span onClick={() => this.openModalWithData("street")}>
                  {getTextSnippet("street", this.props.data)}
                </span>{" "}
                that is my{" "}
                <span onClick={() => this.openModalWithData("occupancyType")}>
                  {getTextSnippet("occupancyType", this.props.data)}
                </span>
                .
              </p>
            </div>
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                I originally bought it for{" "}
                <span onClick={() => this.openModalWithData("price")}>
                  {getTextSnippet("price", this.props.data)}
                </span>
                , and the current loan balance is{" "}
                <span
                  onClick={() => this.openModalWithData("existingLoanBalance")}
                >
                  {getTextSnippet("existingLoanBalance", this.props.data)}
                </span>
                .
              </p>
            </div>
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                I{" "}
                <span onClick={() => this.openModalWithData("takeCashOut")}>
                  {getTextSnippet("takeCashOut", this.props.data)}
                </span>{" "}
                take cash out.
                {this.props.data.takeCashOut &&
                this.props.data.amountOfCashOut !== "0" ? (
                  <>
                    {" "}
                    I want to take out{" "}
                    <span
                      onClick={() => this.openModalWithData("amountOfCashOut")}
                    >
                      {getTextSnippet("amountOfCashOut", this.props.data)}
                    </span>
                    .
                  </>
                ) : null}
              </p>
            </div>
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                My credit score is{" "}
                <span onClick={() => this.openModalWithData("creditScore")}>
                  {getTextSnippet("creditScore", this.props.data)}
                </span>
                .
              </p>
            </div>
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                I am{" "}
                <span onClick={() => this.openModalWithData("isSelfEmployed")}>
                  {getTextSnippet("isSelfEmployed", this.props.data)}
                </span>
                , I am{" "}
                <span onClick={() => this.openModalWithData("isUsCitizen")}>
                  {getTextSnippet("isUsCitizen", this.props.data)}
                </span>
                , and I have{" "}
                <span onClick={() => this.openModalWithData("isVeteran")}>
                  {getTextSnippet("isVeteran", this.props.data)}
                </span>{" "}
                in the U.S. military.
              </p>
            </div>
            {this.props.data.isVeteran && (
              <div className="confirmation-view-paragraph-wrapper">
                <p className="confirmation-view-paragraph">
                  I am{" "}
                  <span
                    onClick={() => this.openModalWithData("disabledVeteran")}
                  >
                    {getTextSnippet("disabledVeteran", this.props.data)}
                  </span>
                  , and I have{" "}
                  <span
                    onClick={() => this.openModalWithData("vaFirstTimeUse")}
                  >
                    {getTextSnippet("vaFirstTimeUse", this.props.data)}
                  </span>
                  .
                </p>
              </div>
            )}
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                I'm interested in these loan options:{" "}
                <span onClick={() => this.openModalWithData("loanOptions")}>
                  {getTextSnippet("loanOptions", this.props.data)}.
                </span>
              </p>
            </div>
            <div className="confirmation-view-paragraph-wrapper">
              <p className="confirmation-view-paragraph">
                <span onClick={() => this.openModalWithData("hasWaivedEscrow")}>
                  {getTextSnippet("hasWaivedEscrow", this.props.data)}
                </span>{" "}
                escrow.*
              </p>
            </div>
          </div>
          <EditActions canSubmit={this.props.isValid} label="Looks Good!" />
        </CenteredPaper>
        <ModifyDataPointModal
          open={this.state.open}
          onClose={() => this.setState({ open: false })}
          setFirstTimeBuyer={(value) => {
            this.setState({ firstTimeBuyer: value });
            localStorage.setItem("firstTimeBuyer", value);
          }}
          data={{
            firstTimeBuyer: this.state.firstTimeBuyer,
            ...this.props.data,
          }}
          openDataName={this.state.openDataName}
          customFormEdit={this.props.customFormEdit}
          onFormEdit={this.props.onFormEdit}
          validationObject={{
            ...this.props.validationSchema.fields,
            price: number()
              .test(
                "price",
                "Your loan amount is too high with the given existing balance.",
                (value) => {
                  if (!value) return false;
                  const minDownPaymentPercent = getDownPaymentMinimum({
                    countyLimits,
                    county: this.props.data.county,
                    state: this.props.data.state,
                    countyFips: this.props.data.countyFips,
                    stateFips: this.props.data.stateFips,
                    loanAmount: value,
                    propertyType: this.props.data.propertyType,
                    occupancyType: this.props.data.occupancyType,
                    lookingTo: this.props.data.takeCashOut
                      ? "Cashout"
                      : "Refinance",
                    isFirstTimeHomebuyer:
                      this.state.firstTimeBuyer === null
                        ? "false"
                        : this.state.firstTimeBuyer,
                  });
                  const maxExistingBalance = this.props.data.takeCashOut
                    ? value -
                      value * (minDownPaymentPercent / 100) -
                      this.props.data.amountOfCashOut
                    : value - value * (minDownPaymentPercent / 100);
                  return (
                    this.props.data.existingLoanBalance <= maxExistingBalance
                  );
                }
              )
              .required(),
            existingLoanBalance: number()
              .test(
                "existingLoanBalance",
                "You cannot exceed the maximum existing loan balance.",
                (value) => {
                  if (!value) return false;
                  const minDownPaymentPercent = getDownPaymentMinimum({
                    countyLimits,
                    county: this.props.data.county,
                    state: this.props.data.state,
                    countyFips: this.props.data.countyFips,
                    stateFips: this.props.data.stateFips,
                    loanAmount: this.props.data.price,
                    propertyType: this.props.data.propertyType,
                    occupancyType: this.props.data.occupancyType,
                    lookingTo: this.props.data.takeCashOut
                      ? "Cashout"
                      : "Refinance",
                    isFirstTimeHomebuyer:
                      this.state.firstTimeBuyer === null
                        ? "false"
                        : this.state.firstTimeBuyer,
                  });
                  const maxExistingBalance = this.props.data.takeCashOut
                    ? this.props.data.price -
                      this.props.data.price * (minDownPaymentPercent / 100) -
                      this.props.data.amountOfCashOut
                    : this.props.data.price -
                      this.props.data.price * (minDownPaymentPercent / 100);
                  return value <= maxExistingBalance;
                }
              )
              .required(),
            amountOfCashOut: number()
              .test(
                "amountOfCashOut",
                "You cannot exceed the maximum cash out amount.",
                (value) => {
                  if (!value) return false;
                  const minDownPaymentPercent = getDownPaymentMinimum({
                    countyLimits,
                    county: this.props.data.county,
                    state: this.props.data.state,
                    countyFips: this.props.data.countyFips,
                    stateFips: this.props.data.stateFips,
                    loanAmount: this.props.data.price,
                    propertyType: this.props.data.propertyType,
                    occupancyType: this.props.data.occupancyType,
                    lookingTo: "Cashout",
                    isFirstTimeHomebuyer:
                      this.state.firstTimeBuyer === null
                        ? "false"
                        : this.state.firstTimeBuyer,
                  });
                  const maxCashOut =
                    this.props.data.price -
                    this.props.data.price * (minDownPaymentPercent / 100) -
                    this.props.data.existingLoanBalance;
                  return value <= maxCashOut;
                }
              )
              .required(),
          }}
        />
      </ILearn>
    );
  }
}

export default withSubmissionEffect(connect()(RefinanceIrqConfirmationView));
